import { UntypedFormGroup, ValidationErrors, AbstractControl } from '@angular/forms';

export class CustomValidator {
  static matchPassword(form: UntypedFormGroup) {
    const password = form.controls.password.value;
    const confirmPassword = form.controls.confirmPassword.value || '';
    if (confirmPassword.length <= 0) {
      return null;
    }
    if (confirmPassword !== password) {
      return {
        mismatch: true,
      };
    }
    return null;
  }

  static validEmail(controls: AbstractControl): ValidationErrors | null {
    const email = controls.value;
    if (!email) {
      return null;
    }
    if (/^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(email)) {
      return null;
    } else {
      return {
        invalidEmail: true,
      };
    }
  }

  static cannotContainSpace(control: AbstractControl): ValidationErrors | null {
    if (control.value && (control.value as string).indexOf(' ') >= 0) {
      return { cannotContainSpace: true };
    }
    return null;
  }

  static leadWhiteSpace(control: AbstractControl): ValidationErrors | null {
    if (control.value && control.value.startsWith(' ')) {
      return { leadWhiteSpace: true };
    }
    return null;
  }

  static containOnlySpace(control: AbstractControl): ValidationErrors | null {
    if (control.value && !control.value.replace(/\s/g, '').length) {
      return { containOnlySpace: true };
    }
    return null;
  }

  static validateIsContactInfo(form: UntypedFormGroup) {
    const status = form.controls.status.value;
    if (status != '3') {
      return {
        required: true,
      };
    }
    return null;
  }
}
